import { getCookie } from "./cookies";
import { getFromLocalStorage } from "./storage";

export const isDebugAPI =
  (typeof process !== "undefined" && process.env.LOGGER_ENABLED) ||
  getFromLocalStorage("logger-enabled") ||
  getCookie("logger-enabled");
